export default __webpack_public_path__ + "static/media/ios-navy.fabf6bb8.svg";